module.exports = __webpack_public_path__ + "static/media/05A.6a241f1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/05A.png
// module id = 253
// module chunks = 0